import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { crmProvideLayout } from '@touch4it/ng-swp/layout-v2';
import { crmProvideTranslate } from '@touch4it/ng-swp/translate';
import { CrmAppConfig } from '@touch4it/ng-swp/core';
import { crmProvideEndpoint } from '@touch4it/ng-swp/endpoint';
import {
  CrmActivationHandleSuccessToken,
  crmAuthInterceptor,
  CrmLoginHandleSuccessToken,
  crmProvideAuth,
  CrmResetPasswordHandleSuccessToken,
} from '@touch4it/ng-swp/auth';
import { CrmUserService } from '@touch4it/ng-swp/user';
import { crmProvideModal } from '@touch4it/ng-swp/modal';
import { crmProvideMessage } from '@touch4it/ng-swp/message';
import { crmProvideEditor } from '@touch4it/ng-swp/editor';

import { namespaceInterceptor } from '~/shared/interceptors/namespace.interceptor';
import { loginHandleSuccess } from '~/shared/providers/login/login-handle-success';
import { resetPasswordHandleSuccess } from '~/shared/providers/reset-password/reset-password-handle-success';
import { activationHandleSuccess } from '~/shared/providers/activation/activation-handle-success';
import { environment } from '~/envs/environment';

import { routes } from './app.routes';
import { endpointConfig } from './config/endpoint.config';
import { authConfig } from './config/auth.config';
import { layoutConfig } from './config/layout.config';
import { UsersApiService } from './api/users/users-api.service';

registerLocaleData(en);

export const appConfig: ApplicationConfig = {
  providers: [
    // NG
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([namespaceInterceptor, crmAuthInterceptor])),

    // ANTD
    provideNzI18n(en_US),

    // SWP
    crmProvideAuth(authConfig),
    crmProvideEndpoint(endpointConfig),
    crmProvideLayout(layoutConfig),
    crmProvideTranslate(),
    crmProvideModal(),
    crmProvideMessage(),
    crmProvideEditor(),
    { provide: CrmAppConfig, useValue: { environment } },
    { provide: CrmUserService, useExisting: UsersApiService },

    // SWP function tokens
    { provide: CrmLoginHandleSuccessToken, useValue: loginHandleSuccess },
    {
      provide: CrmResetPasswordHandleSuccessToken,
      useValue: resetPasswordHandleSuccess,
    },
    {
      provide: CrmActivationHandleSuccessToken,
      useValue: activationHandleSuccess,
    },
  ],
};
